// Centralized validation message helpers (Step 1 inline error implementation)
// Provides consistent, locale-aware required and generic messages.

export function localize(message, lang = 'en') {
  if (!message) return '';
  if (typeof message === 'string') return message;
  if (typeof message === 'object') return message[lang] || message.en || Object.values(message)[0] || '';
  return String(message);
}

export function requiredMessage(type, lang = 'en', override) {
  if (override) return localize(override, lang);
  switch (type) {
    case 'radio':
    case 'radios':
      return lang === 'fr' ? 'Sélectionnez une option' : 'Select an option';
    case 'checkbox':
    case 'checkboxes':
      return lang === 'fr' ? 'Sélectionnez au moins une option' : 'Select at least one option';
    case 'date':
    case 'date-input':
      return lang === 'fr' ? 'Entrez une date' : 'Enter a date';
    default:
      return lang === 'fr' ? 'Ce champ est requis' : 'This field is required';
  }
}

export function predicateMessage(lang = 'en', override) {
  if (override) return localize(override, lang);
  return lang === 'fr' ? 'Valeur invalide' : 'Invalid value';
}

export function emailMessage(lang = 'en', override) {
  if (override) return localize(override, lang);
  return lang === 'fr' ? 'Entrez une adresse électronique valide' : 'Enter a valid email address';
}

export function numberMessage(lang = 'en', override) {
  if (override) return localize(override, lang);
  return lang === 'fr' ? 'Entrez un nombre valide' : 'Enter a valid number';
}

export function patternMessage(lang = 'en', override) {
  if (override) return localize(override, lang);
  return lang === 'fr' ? 'Format invalide' : 'Invalid format';
}

export function minLengthMessage(min, lang = 'en', override) {
  if (override) return localize(override, lang);
  return lang === 'fr' ? `La longueur minimale est de ${min}` : `Minimum length is ${min}`;
}
